import { createContext, useContext, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

// Ра2, Ра7: the actions of a screen («Новый проект», «Выпустить токен», «Завести пользователя», «Новый ключ») stand in the
// header of the page, right, in the same place on every tab of «Проекта» and of «Реестра» — not under a table. The shell
// offers the place (`HeaderSlot`), a screen puts its buttons there with `HeaderActions`. Where there is no shell (the same
// screens inside a host's settings) the buttons stay where the screen put them.

/** `undefined` — no shell (the buttons stay in place); `null` — the shell has not laid out its slot yet. */
const SlotContext = createContext<HTMLElement | null | undefined>(undefined);
export const HeaderSlotProvider = SlotContext.Provider;

/** The place in the page header the actions go to. */
export function HeaderSlot({ onNode }: { onNode: (node: HTMLElement | null) => void }) {
  return <span ref={onNode} className="bug-header-actions" data-slot="header-actions" />;
}

/** The buttons of a screen: in the header slot of the shell, else right here. */
export function HeaderActions({ children }: { children: ReactNode }) {
  const slot = useContext(SlotContext);
  if (slot === undefined) return <div className="jui-row bug-actions bug-header-actions-inline">{children}</div>;
  if (slot === null) return null;
  return createPortal(children, slot);
}
